var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("loader")
    : _c(
        "div",
        {
          staticClass: "card-body position-relative p-0",
          class: _vm.selectContainerClass,
          attrs: { id: "collaborators-select-container" },
        },
        [
          !_vm.emptyCollaborators
            ? _c("div", { staticClass: "w-100" }, [
                _c(
                  "div",
                  { class: _vm.groupClass },
                  [
                    _c("h6", { staticClass: "font-xs text-light-gray mb-0" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.placeholder) + "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "material-input",
                      { attrs: { "no-label": "" } },
                      [
                        _c("v-select-field", {
                          staticClass: "simple-dd no-span",
                          attrs: {
                            placeholder: _vm.placeholder,
                            options: _vm.vSelectCollaboratorsOptions,
                            "default-value": _vm.vSelectDefaultValue,
                            scenario: "agents",
                          },
                          on: {
                            "option:selected": _vm.handleChange,
                            close: _vm.handleClose,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c("no-results", [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "boards.messages.emptyCollaboratorsInBrokerage"
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                ],
                1
              ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }